<div class="form-group">
  <label [attr.for]="id" class="control-label">{{ label }}</label>
  <div class="input-icon"
    [class.input-icon__error]="error"
    [class.input-icon__disabled]="isDisabled">
    <img src="../../../../assets/svgs/{{iconPathAlt.path}}.svg" 
      [alt]="iconPathAlt.alt" 
      *ngIf="iconPathAlt.path.length && !iconPathAlt.rightPosition">
    <input [type]="type" class="form-control"
      [id]="id" 
      [(ngModel)]="value" 
      [readonly]="isDisabled" 
      (keyup)="changeValue($event)"
      autocomplete="off" 
      [placeholder]="placeholder" 
      [maxlength]="maxlength" 
      [minlength]="minlength" 
      [mask]="maskInput" 
      [suffix]="suffixInput" 
      [thousandSeparator]="separator">
    <lib-loading class="loading" *ngIf="loading"></lib-loading>
    <img src="./assets/svgs/{{iconPathAlt.path}}.svg" 
      [alt]="iconPathAlt.alt" 
      *ngIf="iconPathAlt.path.length && iconPathAlt.rightPosition && !loading">
  </div>
  <span class="count" *ngIf="countNumber">
    {{ dataValue.length }} / {{ countNumber }}
  </span>
  <div class="error" *ngIf="error">
    <img src="../../../../assets/svgs/i_error.svg" alt="Icon Error">
    <span class="error_message">{{ messageError }}</span>
  </div>
</div>